import { render, staticRenderFns } from "./vendorfrm.vue?vue&type=template&id=47af77aa"
import script from "./vendorfrm.vue?vue&type=script&lang=js"
export * from "./vendorfrm.vue?vue&type=script&lang=js"
import style0 from "./vendorfrm.vue?vue&type=style&index=0&id=47af77aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports